module.exports = __webpack_public_path__ + "49319cbd53210c32099631ac89b1e70a.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-BoldItalic.ttf
// module id = 413
// module chunks = 0